<template lang="pug">
  #reports-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-manager-track-report" md-label="Путевой отчет менеджера" v-bind:to="{ name: 'ManagerTrackReport'}")
      md-tab(id="tab-realisation-errors-report" md-label="Ошибки в реализациях" v-bind:to="{ name: 'RealisationErrorsReport'}")
      md-tab(id="tab-missing-documents-report" md-label="Отсутствующие документы" v-bind:to="{ name: 'MissingDocumentsReport'}")
      md-tab(id="tab-payment-report" md-label="Оплата" v-bind:to="{ name: 'PaymentReport'}")
      md-tab(id="tab-dispatcher-report" md-label="Диспетчер" v-bind:to="{ name: 'DispatcherReport'}")
</template>

<script>
  export default {
    name: 'reports-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// reports-menu.vue?6a47cc38